module.exports = __webpack_public_path__ + "img/mute_both_mic_speaker.7334d26a.svg";